import React, { useMemo } from 'react';
import { Bar } from 'react-chartjs-2';
import '../styles/HistoricalStats.css';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const AgentActivityGraph = ({ labels = [], datasets = [], style = {} }) => {
  const chartData = useMemo(() => {
    const formattedDatasets = datasets.map(ds => ({
      ...ds,
      stack: 'activity',
      borderRadius: 8,
      maxBarThickness: 25,
    }));

    return {
      labels,
      datasets: formattedDatasets,
    };
  }, [labels, datasets]);

  const options = useMemo(() => ({
    indexAxis: 'y',
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'right',
      },
      tooltip: {
        enabled: true,
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        stacked: true,
        title: {
          display: true,
          text: 'Time (hours)',
        },
      },
      y: {
        stacked: true,
      },
    },
  }), []);

  return <Bar data={chartData} options={options} />;
};

export default AgentActivityGraph;